<template lang="pug">
.variants-editor
  .left
    .sub-title Variantes de Color
  .variants-list(v-if="dataForm.variants && dataForm.variants.length")
    .variant-item(v-for="(v, i) in dataForm.variants" :key="v.product")
      img.variant-thumb(
        v-if="thumbUrl(v.product)"
        :src="thumbUrl(v.product)"
        :alt="v.product")
      .variant-thumb.variant-thumb-empty(v-else)
      .color-picker-wrapper(:title="'Color de ' + v.product")
        input(type="color" :value="v.color || '#cccccc'" @input="updateColor(i, $event.target.value)")
      .variant-name {{ variantLabel(v) }}
      .variant-remove.pointer(@click="remove(i)") ✕
  .form-section
    .input-container
      input.input(
        v-model="search"
        @keypress.enter.prevent="addByName"
        autocomplete="ño"
        :disabled="isSearching"
        placeholder=" ")
      label.label(:class="{ show: search }") Agregar variante (nombre del producto + Enter)
    .variant-error(v-if="error") {{ error }}
</template>

<script>
import gql from '@my/graphql'
import gqlProduct from '@/graphql/product'
import config from '@/config'

const IMAGE_PATH = config.IMAGES.path

export default {
  name: 'VariantsEditor',

  props: {
    dataForm: Object,
    dataOriginal: Object,
    fillData: Boolean
  },

  data () {
    return {
      search: '',
      error: '',
      isSearching: false,
      variantMeta: {}
    }
  },

  async mounted () {
    if (this.fillData && this.dataForm.variants && this.dataForm.variants.length) {
      await this.loadMeta(this.dataForm.variants.map(v => v.product))
    }
  },

  methods: {
    async addByName () {
      const name = (this.search || '').trim().toLowerCase()
      if (!name) return

      if (this.dataForm.variants && this.dataForm.variants.some(v => v.product === name)) {
        this.error = 'Ya está en la lista'
        return
      }

      this.isSearching = true
      this.error = ''

      const response = await gql.query(gqlProduct.GET_BY_PRODUCT, { product: name })
      this.isSearching = false

      const data = response && response.data && response.data.getByProduct
      if (!data) {
        this.error = `El producto "${name}" no existe`
        return
      }

      this.$set(this.variantMeta, name, {
        brand: data.brand,
        folder: data.folder,
        subfolder: data.subfolder,
        image: (data.images || [])[0] || '',
        colorName: (data.colors && data.colors[0]) || ''
      })

      if (!this.dataForm.variants) this.$set(this.dataForm, 'variants', [])
      this.dataForm.variants.push({ product: name, color: '#cccccc' })
      this.search = ''
      this.error = ''
    },

    async loadMeta (names) {
      for (const name of names) {
        if (this.variantMeta[name]) continue
        const response = await gql.query(gqlProduct.GET_IMAGES_BY_PRODUCT, { product: name })
        const data = response && response.data && response.data.getByProduct
        if (data) {
          this.$set(this.variantMeta, name, {
            brand: data.brand,
            folder: data.folder,
            subfolder: data.subfolder,
            image: (data.images || [])[0] || ''
          })
        }
      }
    },

    variantLabel (v) {
      const colorName = v.colorName || (this.variantMeta[v.product] && this.variantMeta[v.product].colorName)
      if (!colorName) return v.product
      return `${v.product} - ${colorName}`
    },

    thumbUrl (name) {
      const meta = this.variantMeta[name]
      if (!meta || !meta.image) return ''
      return `${IMAGE_PATH}/${meta.brand}/${meta.folder}/${meta.subfolder}/${meta.image}`
    },

    updateColor (i, hex) {
      this.$set(this.dataForm.variants[i], 'color', hex)
    },

    remove (i) {
      this.dataForm.variants.splice(i, 1)
    }
  }
}
</script>

<style lang="stylus" scoped>
.variants-list
  display flex
  flex-direction column
  gap .6rem
  margin 1rem 0

.variant-item
  display flex
  align-items center
  gap .8rem
  padding .4rem .8rem
  border 1px solid var(--color-border)
  border-radius .4rem

.variant-thumb
  width 3.5rem
  height 4.5rem
  object-fit cover
  border-radius .3rem
  flex-shrink 0
  border 1px solid var(--color-border)

.variant-thumb-empty
  background-color var(--color-background)

.color-picker-wrapper
  flex-shrink 0

.color-picker-wrapper input[type="color"]
  width 2rem
  height 2rem
  border-radius 50%
  border 1px solid rgba(0, 0, 0, 0.2)
  padding 0
  cursor pointer
  appearance none
  -webkit-appearance none

.color-picker-wrapper input[type="color"]::-webkit-color-swatch-wrapper
  padding 0
  border-radius 50%

.color-picker-wrapper input[type="color"]::-webkit-color-swatch
  border none
  border-radius 50%

.variant-name
  flex 1
  font-size 1rem
  font-weight 500

.variant-remove
  font-size 1rem
  opacity .5
  padding .2rem .4rem

.variant-remove:hover
  opacity 1

.variant-error
  color var(--color-error, #e53935)
  font-size .9rem
  margin-top .4rem
</style>



// WEBPACK FOOTER //
// src/components/pages/product/VariantsEditor.vue